"use strict";
exports.__esModule = true;
exports.DEFAULT_ID_ATTR_KEY = void 0;
exports.DEFAULT_ID_ATTR_KEY = "id";
